module.exports = __webpack_public_path__ + "static/img/step3.65ebd478.png";